module.exports = "/_next/static/images/UseSegment-26d153ce679347c7b88f667faa175ce5.webp";